import { TermsConditionsType } from "../enums/whitelisting.enums";
import { ITermsConditionsData } from "../interfaces/user.interface";

export const termsAndConditionsConfig: ITermsConditionsData[] = [
  {
    isChecked: false,
    type: TermsConditionsType.Investments,
    message:
      "I understand that early-stage investments can be extremely risky and that I may potentially lose the capital that I have provided",
    touched: false,
  },
  {
    isChecked: false,
    type: TermsConditionsType.ApeIntoProjects,
    message:
      "I will perform the necessary due diligence when presented with opportunities and commit to not blindly ape into projects",
    touched: false,
  },
  {
    isChecked: false,
    type: TermsConditionsType.Contribute,
    message:
      "I am willing to step up and contribute should there be a fit in the skillsets that I have to offer",
    touched: false,
  },
  {
    isChecked: false,
    type: TermsConditionsType.NotMandatory,
    message:
      "I understand that it is not mandatory for me to participate in any of the opportunities presented and in no circumstance should I feel obligated to do so",
    touched: false,
  },
  {
    isChecked: false,
    type: TermsConditionsType.RemainActive,
    message:
      "I understand that it is important for me to remain active in following up with the deals I have subscribed to",
    touched: false,
  },
  {
    isChecked: false,
    type: TermsConditionsType.TermsConditions,
    message:
      "By participating in the opportunities presented, I am agreeable to the terms and conditions extended related to the opportunity as well as its organization.",
    touched: false,
  },
];
